import React from 'react';
import { motion } from 'framer-motion';
import { toast } from 'react-toastify';

const plans = [
  {
    id: 'basic',
    title: 'Basic',
    price: '€4',
    freq: '/FTE',
    tag: 'Your current plan',
    features: [
      'Custom AI-augmented dashboard',
      'Up to 250,000 tracked visits',
      'Normal support',
      '0–50 FTE',
    ],
    cta: 'Current Plan',
    disabled: true,
  },
  {
    id: 'premium',
    title: 'Premium',
    price: '€7',
    freq: '/FTE',
    tag: 'For startups',
    features: [
      'Custom AI-augmented dashboard',
      'Predictive team modelling',
      'Premium support',
      '10–150 FTE',
    ],
    cta: 'Upgrade',
  },
  {
    id: 'enterprise',
    title: 'Enterprise',
    price: 'Contact',
    freq: '',
    tag: 'For big companies',
    features: [
      'Custom AI-augmented dashboard',
      'Predictive team modelling',
      'Dedicated support',
      '150+ FTE',
    ],
    cta: 'Contact support',
  },
];

const SubscriptionPlansPopover = ({ onClose }) => {
  const handlePlanClick = planId => {
    if (planId === 'premium') {
      toast.success('Premium upgrade requested');
    } else if (planId === 'enterprise') {
      toast.info('Sales will contact you shortly');
    }
    onClose();
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 20 }}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm"
    >
      <motion.div className="w-[92%] max-w-2xl rounded-xl bg-white p-4 shadow-xl sm:w-full md:max-w-5xl md:p-6">
        <div className="mb-6 flex items-center justify-between">
          <h3 className="text-lg font-semibold text-black">Select a Plan</h3>
          <button onClick={onClose} className="text-gray-500 transition hover:text-gray-700">
            ✕
          </button>
        </div>

        <div className="grid gap-4 sm:gap-6 md:grid-cols-3">
          {plans.map((plan, idx) => (
            <motion.div
              key={plan.id}
              whileHover={{ scale: 1.02 }}
              className={`rounded-xl border ${
                plan.disabled ? 'border-gray-300' : 'border-blue-400'
              } bg-white p-4 shadow-sm md:p-6`}
            >
              <p className="mb-1 text-xs text-gray-500">{plan.tag}</p>
              <h4 className="text-xl font-bold text-black">{plan.title}</h4>
              <p className="mb-4 mt-1 text-2xl font-semibold text-black">
                {plan.price}
                <span className="ml-1 text-sm text-gray-500">{plan.freq}</span>
              </p>

              <ul className="mb-6 space-y-2 text-sm text-black">
                {plan.features.map((feature, i) => (
                  <li key={i} className="flex items-start">
                    <svg
                      className="mr-2 mt-1 h-4 w-4 text-blue-600"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                    {feature}
                  </li>
                ))}
              </ul>

              <button
                disabled={plan.disabled}
                onClick={() => handlePlanClick(plan.id)}
                className={`w-full rounded-lg py-2 text-sm font-medium transition ${
                  plan.disabled
                    ? 'cursor-not-allowed bg-gray-100 text-gray-400'
                    : 'bg-blue-600 text-white hover:bg-blue-700'
                }`}
              >
                {plan.cta}
              </button>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </motion.div>
  );
};

export default SubscriptionPlansPopover;
